import WarningIcon from '@atlaskit/icon/core/warning';
import SuccessIcon from '@atlaskit/icon/core/success';
import { token } from '@atlaskit/tokens';
import type { NewCoreIconProps } from '@atlaskit/icon/base-new';
import type { IconColor } from '@atlaskit/tokens/css-type-schema';
import type { MessageDescriptor } from '@atlassian/jira-intl';
import { RecommendationStatus } from '@atlassian/jira-insights-sprint-commitment/src/common/constants.tsx';
import { EstimationUnit } from '@atlassian/jira-insights-common-constants/src/common/utils/constants.tsx';
import messages from './messages.tsx';
import type { RecommendationTarget, SupportedEstimationUnit } from './types.tsx';

export const RecommendationIcon: Record<
	RecommendationTarget,
	{ Icon: (props: NewCoreIconProps) => JSX.Element; iconColor: IconColor }
> = {
	[RecommendationStatus.BELOW_TARGET]: {
		Icon: WarningIcon,
		iconColor: token('color.icon.warning'),
	},
	[RecommendationStatus.ABOVE_TARGET]: {
		Icon: WarningIcon,
		iconColor: token('color.icon.warning'),
	},
	[RecommendationStatus.WITHIN_TARGET]: {
		Icon: SuccessIcon,
		iconColor: token('color.icon.success'),
	},
} as const;

export const RecommendationLabel: Record<RecommendationTarget, MessageDescriptor> = {
	[RecommendationStatus.BELOW_TARGET]: messages.belowTargetLabel,
	[RecommendationStatus.ABOVE_TARGET]: messages.aboveTargetLabel,
	[RecommendationStatus.WITHIN_TARGET]: messages.withinTargetLabel,
} as const;

export const TooltipMessages: Record<
	SupportedEstimationUnit,
	Record<RecommendationTarget, MessageDescriptor>
> = {
	[EstimationUnit.STORY_POINTS]: {
		[RecommendationStatus.BELOW_TARGET]: messages.storyPointsBelowTargetTooltip,
		[RecommendationStatus.WITHIN_TARGET]: messages.storyPointsWithinTargetTooltip,
		[RecommendationStatus.ABOVE_TARGET]: messages.storyPointsAboveTargetTooltip,
	},
	[EstimationUnit.ISSUE_COUNT]: {
		[RecommendationStatus.BELOW_TARGET]: messages.issueCountBelowTargetTooltip,
		[RecommendationStatus.WITHIN_TARGET]: messages.issueCountWithinTargetTooltip,
		[RecommendationStatus.ABOVE_TARGET]: messages.issueCountAboveTargetTooltip,
	},
	[EstimationUnit.TIME_TRACKING]: {
		[RecommendationStatus.BELOW_TARGET]: messages.timeTrackingBelowTargetTooltip,
		[RecommendationStatus.WITHIN_TARGET]: messages.timeTrackingWithinTargetTooltip,
		[RecommendationStatus.ABOVE_TARGET]: messages.timeTrackingAboveTargetTooltip,
	},
} as const;
